export default "__VITE_ASSET__cd186194__"